import React, { useEffect, useState } from "react";
import { useLocation, Link } from "react-router-dom";
import {
  GetLeavsAllemployesss,
  leaverequeststatuschange,
  recallleaverequest,
} from "../../services/dataService";
import toast from "react-hot-toast";
import { IconCheck, IconX, IconArrowRight } from "@tabler/icons-react";
import { getSecureItem } from "../../services/SecureStorage";

function PendingLeaveToday() {
  const departmentIds = getSecureItem("DepartmentId") || ""; // Retrieve the value or default to an empty string
  const Dep = departmentIds.split(",")[0] || null; // Split and get the first ID, or set to null if not found
  const UID = getSecureItem("userId");
  const isAdmin = getSecureItem("IsAdmin");
  const UserType = getSecureItem("UserType");
  const location = useLocation();

  const [loading, setLoading] = useState(false);
  const [allEmpLeaveReq, setAllEmpLeaveReq] = useState([]);
  const [pendingLeavesAll, setPendingLeavesAll] = useState([]);
  const [filteredLeaves, setFilteredLeaves] = useState([]);
  const [pendingLeave, setPendingLeave] = useState(
    () => location.state?.pendingLeave || []
  );

  // Modal states
  const [approveModal, setApproveModal] = useState(false);
  const [rejectModal, setRejectModal] = useState(false);
  const [selectedRequest, setSelectedRequest] = useState(null);
  const [remarks, setRemarks] = useState("");
  const [NoofDays, setNoofDays] = useState("");

  // Filter states
  const [searchTerm, setSearchTerm] = useState("");
  const [selectedDepartment, setSelectedDepartment] = useState("");
  const [selectedProfitCenter, setSelectedProfitCenter] = useState("");
  const [departments, setDepartments] = useState([]);
  const [profitCenters, setProfitCenters] = useState([]);

  // Calculate max days between two dates
  const calculateMaxDays = (fromDate, toDate) => {
    if (!fromDate || !toDate) return 0;
    const from = new Date(fromDate);
    const to = new Date(toDate);
    const diffInMs = to - from;
    const diffInDays = Math.ceil(diffInMs / (1000 * 60 * 60 * 24));
    return diffInDays + 1;
  };

  // Handle status change (approve/reject/forward)
  const handleStatusChange = async (e, status, selectedRequest) => {
    e.preventDefault();
    setLoading(true);

    const details = {
      Remarks: remarks,
      UserId: UID,
      Status: status,
      Id: selectedRequest?.Id,
      NoOfDays: NoofDays ? NoofDays : selectedRequest?.NoOfDays,
    };

    try {
      const response = await leaverequeststatuschange(details);
      if (response.data) {
        let statusMessage = "";
        if (status === 1) {
          statusMessage = "approved";
        } else if (status === 2) {
          statusMessage = "rejected";
        } else {
          statusMessage = "Forwarded to next level";
        }

        toast.success(`Request ${statusMessage} successfully`);
        setRejectModal(false);
        setApproveModal(false);
        fetchAllEmpLeaveReq();
      }
    } catch (error) {
      console.error("Leave Request Error:", error);
      toast.error(
        error.response?.data?.message || "Error submitting leave request"
      );
    } finally {
      setLoading(false);
    }
  };

  // Handle recall/cancel leave
  const handleRecall = (data) => {
    const Payload = {
      Id: data.Id,
    };
    recallleaverequest(Payload).then((response) => {
      if (response) {
        toast.success("Leave Request Recalled Successfully");
        fetchAllEmpLeaveReq();
      }
    });
  };

  const fetchAllEmpLeaveReq = async () => {
    try {
      setLoading(true);
      const data = {
        fromDate: null,
        toDate: null,

        UserId: UID,
      };

      const response = await GetLeavsAllemployesss(data);

      if (response?.data?.data) {
        setAllEmpLeaveReq(response.data.data);
      } else {
        console.error("Invalid response structure:", response);
        toast.error("Failed to load leave requests - invalid data format");
      }
    } catch (error) {
      console.error("API Error:", error);
      toast.error(
        error.response?.data?.message || "Failed to fetch leave requests"
      );
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchAllEmpLeaveReq();
  }, []);

  useEffect(() => {
    if (pendingLeave && Array.isArray(pendingLeave)) {
      const LeaveFromDashBoard = allEmpLeaveReq.filter((el) =>
        pendingLeave.some((p) => p.Id === el.Id)
      );
      setPendingLeavesAll(LeaveFromDashBoard);
    }
  }, [pendingLeave, allEmpLeaveReq]);

  // Extract unique departments and profit centers
  useEffect(() => {
    const uniqueDepartments = [
      ...new Set(
        pendingLeavesAll.map((leave) => leave.DepartmentName).filter(Boolean)
      ),
    ];
    setDepartments(uniqueDepartments);

    const uniqueProfitCenters = [
      ...new Set(
        pendingLeavesAll.map((leave) => leave.ProfitcenterName).filter(Boolean)
      ),
    ];
    setProfitCenters(uniqueProfitCenters);
  }, [pendingLeavesAll]);

  // Filter leaves based on search, department, and profit center
  useEffect(() => {
    let filtered = pendingLeavesAll;

    if (searchTerm) {
      filtered = filtered.filter(
        (leave) =>
          leave.Name?.toLowerCase().includes(searchTerm.toLowerCase()) ||
          leave.NameWithCode?.toLowerCase().includes(
            searchTerm.toLowerCase()
          ) ||
          leave.DepartmentName?.toLowerCase().includes(searchTerm.toLowerCase())
      );
    }

    if (selectedDepartment) {
      filtered = filtered.filter(
        (leave) => leave.DepartmentName === selectedDepartment
      );
    }

    if (selectedProfitCenter) {
      filtered = filtered.filter(
        (leave) => leave.ProfitcenterName === selectedProfitCenter
      );
    }

    setFilteredLeaves(filtered);
  }, [pendingLeavesAll, searchTerm, selectedDepartment, selectedProfitCenter]);

  // Helper functions
  const getEmployeeCode = (nameWithCode) => {
    if (!nameWithCode) return "N/A";
    const parts = nameWithCode.split(" - ");
    return parts.length > 1 ? parts[1] : "N/A";
  };

  const getEmployeeName = (nameWithCode, name) => {
    if (nameWithCode) {
      const parts = nameWithCode.split(" - ");
      return parts[0] || name || "N/A";
    }
    return name || "N/A";
  };

  const formatDate = (dateString) => {
    if (!dateString) return "N/A";
    const date = new Date(dateString);
    return date.toLocaleDateString("en-GB", {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
    });
  };

  return (
    <div className="container mx-auto p-6 bg-white min-h-screen">
      {/* Header Section */}
      <div className="mb-6">
        <div className="flex items-center justify-between mb-4">
          <div>
            <h1 className="text-2xl font-bold text-gray-800">
              Leave Request Approval Pending
            </h1>
            {isAdmin == 0 && filteredLeaves?.length > 0 && (
              <>
                <p className="text-2xl text-gray-800">
                  Department:{" "}
                  {[
                    ...new Set(filteredLeaves.map((el) => el.DepartmentName)),
                  ].join(", ")}
                </p>
              </>
            )}

            <p className="text-sm text-gray-600 mt-1">
              Total Pending Leave Requests: {filteredLeaves.length}
            </p>
          </div>
          <Link
            to="/"
            className="px-4 py-2 bg-green-600 text-white rounded-md hover:bg-green-700 focus:outline-none focus:ring-2 focus:ring-green-500 focus:ring-offset-2 flex items-center"
          >
            <svg
              className="w-4 h-4 mr-2"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M10 19l-7-7m0 0l7-7m-7 7h18"
              />
            </svg>
            Back to Dashboard
          </Link>
        </div>

        {/* Filter Section */}
        <div className="bg-gray-50 p-4 rounded-lg mb-4">
          <div className="flex flex-col md:flex-row gap-4">
            {/* Search Input */}
            <div className="flex-1">
              <label className="block text-sm font-medium text-gray-700 mb-1">
                Search by Name, Code, or Department
              </label>
              <input
                type="text"
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                placeholder="Enter employee name, code, or department..."
                className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
              />
            </div>

            {/* Department Filter */}
            {isAdmin == 1 && (
              <div className="md:w-64">
                <label className="block text-sm font-medium text-gray-700 mb-1">
                  Filter by Department
                </label>
                <select
                  value={selectedDepartment}
                  onChange={(e) => setSelectedDepartment(e.target.value)}
                  className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                >
                  <option value="">All Departments</option>
                  {departments.map((dept, index) => (
                    <option key={index} value={dept}>
                      {dept}
                    </option>
                  ))}
                </select>
              </div>
            )}

            {/* Profit Center Filter */}
            <div className="md:w-64">
              <label className="block text-sm font-medium text-gray-700 mb-1">
                Filter by Profit Center
              </label>
              <select
                value={selectedProfitCenter}
                onChange={(e) => setSelectedProfitCenter(e.target.value)}
                className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
              >
                <option value="">All Profit Centers</option>
                {profitCenters.map((center, index) => (
                  <option key={index} value={center}>
                    {center}
                  </option>
                ))}
              </select>
            </div>
          </div>
        </div>
      </div>

      {/* Loading State */}
      {loading && (
        <div className="flex justify-center items-center py-8">
          <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-500"></div>
          <span className="ml-2 text-gray-600">Loading...</span>
        </div>
      )}

      {/* Table */}
      {!loading && (
        <div className="overflow-x-auto shadow-lg rounded-lg">
          <table className="min-w-full bg-white border border-gray-200">
            <thead className="bg-gray-50">
              <tr>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider border-b">
                  Sl No
                </th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider border-b">
                  Employee Code
                </th>

                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider border-b">
                  Employee Name
                </th>
                {isAdmin == 1 && (
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider border-b">
                    Department
                  </th>
                )}
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider border-b">
                  Leave Type
                </th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider border-b">
                  Start Date
                </th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider border-b">
                  End Date
                </th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider border-b">
                  No of Days
                </th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider border-b">
                  Actions
                </th>
              </tr>
            </thead>
            <tbody className="bg-white divide-y divide-gray-200">
              {filteredLeaves.length > 0 ? (
                filteredLeaves.map((leave, index) => {
                  // Parse approval levels data
                  const totalLevels =
                    typeof leave.TotalLevels === "string"
                      ? JSON.parse(leave.TotalLevels)
                      : leave.TotalLevels || [];
                  const totalLevelCount =
                    leave.TotalLevelCount || totalLevels.length;
                  const currentLevel = leave.CurrentLevel || 0;
                  const isFinalApproval = currentLevel === totalLevelCount;

                  return (
                    <tr
                      key={leave.Id}
                      className="hover:bg-gray-50 transition-colors duration-200"
                    >
                      <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900 border-b">
                        {index + 1}
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900 border-b">
                        {getEmployeeCode(leave.NameWithCode)}
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900 border-b">
                        {getEmployeeName(leave.NameWithCode, leave.Name)}
                      </td>
                      {isAdmin == 1 && (
                        <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900 border-b">
                          {leave.DepartmentName || "N/A"}
                        </td>
                      )}
                      <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900 border-b">
                        {leave.LeaveTypeName || "N/A"}
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900 border-b">
                        {formatDate(leave.FromDate)}
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900 border-b">
                        {formatDate(leave.ToDate)}
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900 border-b">
                        {leave.NoOfDays || 0}
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900 border-b">
                        <div className="flex items-center gap-2">
                          {/* For status 11 or 2, don't show any buttons */}
                          {leave.Status === 11 || leave.Status === 2 ? null : (
                            <>
                              {/* Approved items - ONLY show Cancel button */}
                              {leave.Status === 1 ? (
                                <button
                                  disabled={
                                    UserType?.toLowerCase() === "departmenthead"
                                  }
                                  className="px-3 py-1 bg-red-500 text-white rounded hover:bg-red-600 text-xs flex items-center"
                                  onClick={() => handleRecall(leave)}
                                >
                                  Cancel Leave
                                </button>
                              ) : (
                                <>
                                  {/* Case 1: Direct Approval Flow */}
                                  {leave.IsDirect === true && (
                                    <>
                                      <button
                                        className="px-3 py-1 bg-green-500 text-white rounded hover:bg-green-600 text-xs flex items-center"
                                        onClick={() => {
                                          setSelectedRequest(leave);
                                          setNoofDays(leave.NoOfDays);
                                          setApproveModal(true);
                                        }}
                                      >
                                        <IconCheck size={16} className="mr-1" />{" "}
                                        Approve
                                      </button>

                                      {!isFinalApproval && (
                                        <button
                                          className="btn btn-success"
                                          onClick={(e) => {
                                            setSelectedRequest(leave);
                                            setNoofDays(leave.NoOfDays);
                                            handleStatusChange(
                                              e,
                                              leave.Status === 0
                                                ? 3
                                                : leave.Status + 1,
                                              leave
                                            );
                                          }}
                                        >
                                          <IconArrowRight
                                            size={16}
                                            className="mr-1"
                                          />{" "}
                                          Forward
                                        </button>
                                      )}
                                    </>
                                  )}

                                  {/* Case 2: Multi-Level Approval Flow */}
                                  {leave.IsDirect === false && (
                                    <>
                                      {isFinalApproval ||
                                      totalLevelCount === 1 ? (
                                        <button
                                          className="px-3 py-1 bg-green-500 text-white rounded hover:bg-green-600 text-xs flex items-center"
                                          onClick={() => {
                                            setSelectedRequest(leave);
                                            setNoofDays(leave.NoOfDays);
                                            setApproveModal(true);
                                          }}
                                        >
                                          <IconCheck
                                            size={16}
                                            className="mr-1"
                                          />{" "}
                                          Approve
                                        </button>
                                      ) : (
                                        <button
                                          className="btn btn-success"
                                          onClick={(e) => {
                                            setSelectedRequest(leave);
                                            setNoofDays(leave.NoOfDays);
                                            handleStatusChange(
                                              e,
                                              leave.Status === 0
                                                ? 3
                                                : leave.Status + 1,
                                              leave
                                            );
                                          }}
                                        >
                                          <IconArrowRight
                                            size={16}
                                            className="mr-1"
                                          />{" "}
                                          Forward
                                        </button>
                                      )}
                                    </>
                                  )}

                                  {/* Case 3: Simple Approval (IsDirect null) */}
                                  {leave.IsDirect === null && (
                                    <button
                                      className="px-3 py-1 bg-green-500 text-white rounded hover:bg-green-600 text-xs flex items-center"
                                      onClick={() => {
                                        setSelectedRequest(leave);
                                        setNoofDays(leave.NoOfDays);
                                        setApproveModal(true);
                                      }}
                                    >
                                      <IconCheck size={16} className="mr-1" />{" "}
                                      Approve
                                    </button>
                                  )}

                                  {/* Reject button (shown for all non-approved items) */}
                                  <button
                                    className="px-3 py-1 bg-red-500 text-white rounded hover:bg-red-600 text-xs flex items-center"
                                    onClick={() => {
                                      setSelectedRequest(leave);
                                      setRejectModal(true);
                                    }}
                                  >
                                    <IconX size={16} className="mr-1" /> Reject
                                  </button>
                                </>
                              )}
                            </>
                          )}
                        </div>
                      </td>
                    </tr>
                  );
                })
              ) : (
                <tr>
                  <td
                    colSpan="9"
                    className="px-6 py-8 text-center text-gray-500"
                  >
                    {searchTerm || selectedDepartment || selectedProfitCenter
                      ? "No pending leave requests found matching your search criteria."
                      : "No pending leave requests found."}
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      )}

      {/* Results Count */}
      {!loading && filteredLeaves.length > 0 && (
        <div className="mt-4 text-sm text-gray-600">
          Showing {filteredLeaves.length} of {pendingLeavesAll.length} pending
          requests
          {(searchTerm || selectedDepartment || selectedProfitCenter) &&
            " (filtered)"}
        </div>
      )}

      {/* Approve Modal */}
      {approveModal && selectedRequest && (
        <div className="fixed inset-0 bg-black/30 backdrop-blur-[3px] z-50 flex items-center justify-center">
          <form
            onSubmit={(e) => handleStatusChange(e, 1, selectedRequest)}
            className="bg-white p-6 rounded-lg shadow-xl w-96"
          >
            <h2 className="text-xl mb-4">Approve Leave Request</h2>

            {/* Remarks Textarea */}
            <textarea
              className="w-full p-2 border rounded mb-4"
              placeholder="Approval Remarks"
              value={remarks}
              onChange={(e) => setRemarks(e.target.value)}
              rows="4"
              required
            />

            {/* No of Days Leave Display */}
            <p className="mb-2">
              No Of Days Leave:{" "}
              {calculateMaxDays(
                selectedRequest.FromDate,
                selectedRequest.ToDate
              )}
            </p>

            {/* Input for No of Days */}
            <input
              className="w-full p-2 border rounded mb-4"
              name="NoOfDays"
              type="number"
              value={NoofDays}
              onChange={(e) => setNoofDays(e.target.value)}
              min={0.5}
              step={0.5} // 👈 add this
              max={calculateMaxDays(
                selectedRequest.FromDate,
                selectedRequest.ToDate
              )}
              required
            />

            {/* Action Buttons */}
            <div className="flex justify-end space-x-2">
              <button
                type="button"
                className="px-4 py-2 bg-gray-300 rounded hover:bg-gray-400"
                onClick={() => setApproveModal(false)}
              >
                Cancel
              </button>
              <button
                type="submit"
                className="px-4 py-2 bg-green-500 text-white rounded hover:bg-green-600"
                disabled={
                  NoofDays < 0.5 ||
                  NoofDays < 0.5 ||
                  NoofDays >
                    calculateMaxDays(
                      selectedRequest.FromDate,
                      selectedRequest.ToDate
                    )
                }
              >
                Approve
              </button>
            </div>
          </form>
        </div>
      )}

      {/* Reject Modal */}
      {rejectModal && selectedRequest && (
        <div className="fixed inset-0 bg-black/30 backdrop-blur-[3px] z-50 flex items-center justify-center">
          <form
            onSubmit={(e) => handleStatusChange(e, 2, selectedRequest)}
            className="bg-white p-6 rounded-lg shadow-xl w-96"
          >
            <h2 className="text-xl mb-4">Reject Leave Request</h2>
            <textarea
              className="w-full p-2 border rounded mb-4"
              placeholder="Rejection Remarks"
              value={remarks}
              onChange={(e) => setRemarks(e.target.value)}
              rows="4"
              required
            />
            <div className="flex justify-end space-x-2">
              <button
                type="button"
                className="px-4 py-2 bg-gray-300 rounded hover:bg-gray-400"
                onClick={() => setRejectModal(false)}
              >
                Cancel
              </button>
              <button
                type="submit"
                className="px-4 py-2 bg-red-500 text-white rounded hover:bg-red-600"
              >
                Reject
              </button>
            </div>
          </form>
        </div>
      )}
    </div>
  );
}

export default PendingLeaveToday;
